import { GraphQlClient } from '@intelipost-js/secure-providers';
import { ScToast } from '@intelipost-js/secure-components';

export default {
  getCompanySecurity({ commit }) {
    commit('setLoading', true);

    return GraphQlClient.query(`
    query{
      getCompanySecurity{
        old_password_check_amount
        max_wrong_password_attempt
        token_life_time_in_minutes
        token_idle_timeout_in_minutes
        expire_password_in_days
        password_min_length
        password_rules
      }
    }
    `)
    .then(({ data }) => {
      const { getCompanySecurity: companySecurity } = data;
      commit('setCompanySecurity', companySecurity || {});
      commit('setLoading', false);
      return Promise.resolve(data);
    })
    .catch((err) => {
      commit('setLoading', false);
      return Promise.reject(err);
    });
  },

  getCompanySecurityMigrated({ commit }) {
    commit('setLoading', true);

    return GraphQlClient.query(`
    query{
      getCompanySecurityMigrated{
        old_password_check_amount
        max_wrong_password_attempt
        token_life_time_in_minutes
        token_idle_timeout_in_minutes
        expire_password_in_days
        password_min_length
        authf2
        password_rules
      }
    }
    `)
    .then(({ data }) => {
      const { getCompanySecurityMigrated: companySecurity } = data;
      commit('setCompanySecurity', companySecurity || {});
      commit('setLoading', false);
      return Promise.resolve(data);
    })
    .catch((err) => {
      commit('setLoading', false);
      return Promise.reject(err);
    });
  },

  updateCompanySecurity({ commit }, companySecurity) {
    commit('setLoading', true);

    return GraphQlClient.mutation(`
    mutation (
      $old_password_check_amount: Int!
      $max_wrong_password_attempt: Int!
      $token_life_time_in_minutes: Int!
      $token_idle_timeout_in_minutes: Int!
      $expire_password_in_days: Int!
      $password_min_length: Int!
      $password_rules: [Int]!
    ) {
      updateCompanySecurity (
        old_password_check_amount: $old_password_check_amount
        max_wrong_password_attempt: $max_wrong_password_attempt
        token_life_time_in_minutes: $token_life_time_in_minutes
        token_idle_timeout_in_minutes: $token_idle_timeout_in_minutes
        expire_password_in_days: $expire_password_in_days
        password_min_length: $password_min_length
        password_rules: $password_rules
      ) {
        old_password_check_amount
        max_wrong_password_attempt
        token_life_time_in_minutes
        token_idle_timeout_in_minutes
        expire_password_in_days
        password_min_length
        password_rules
      }
    }`, companySecurity)
    .then(({ data }) => {
      commit('setLoading', false);
      ScToast.success('Dados atualizados com sucesso');
      return Promise.resolve(data);
    })
    .catch((err) => {
      commit('setLoading', false);
      return Promise.reject(err);
    });
  },

  updateCompanySecurityMigrated({ commit }, companySecurity) {
    commit('setLoading', true);

    return GraphQlClient.mutation(`
    mutation (
      $old_password_check_amount: Int!
      $max_wrong_password_attempt: Int!
      $token_life_time_in_minutes: Int!
      $token_idle_timeout_in_minutes: Int!
      $expire_password_in_days: Int!
      $password_min_length: Int!
      $authf2: Boolean!
      $password_rules: [Int]!
    ) {
      updateCompanySecurityMigrated (
        old_password_check_amount: $old_password_check_amount
        max_wrong_password_attempt: $max_wrong_password_attempt
        token_life_time_in_minutes: $token_life_time_in_minutes
        token_idle_timeout_in_minutes: $token_idle_timeout_in_minutes
        expire_password_in_days: $expire_password_in_days
        password_min_length: $password_min_length
        authf2: $authf2
        password_rules: $password_rules
      ) {
        old_password_check_amount
        max_wrong_password_attempt
        token_life_time_in_minutes
        token_idle_timeout_in_minutes
        expire_password_in_days
        password_min_length
        authf2
        password_rules
      }
    }`, companySecurity)
    .then(({ data }) => {
      commit('setLoading', false);
      ScToast.success('Dados atualizados com sucesso');
      return Promise.resolve(data);
    })
    .catch((err) => {
      commit('setLoading', false);
      return Promise.reject(err);
    });
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/company-security/store/actions.js